import { Select } from '@mantine/core';
import classNames from './Select.module.css';

export default Select.extend({
  defaultProps: {
    checkIconPosition: 'right',
    clearable: true,
    placeholder: 'All',
    searchable: true,
    size: 'md',
    withCheckIcon: true,
  },
  classNames,
});
